import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectAuthUser,
  selectAuthLoading,
  selectAuthError,
  selectIsAuthenticated,
  selectAwaitingOtp,
  selectOtpEmail,
  loginUser,
  logoutUser,
  verifyOtp,
  backToLogin,
} from '../slice/authSlice';

export function useAuth() {
  const dispatch = useDispatch();
  const user = useSelector(selectAuthUser);
  const loading = useSelector(selectAuthLoading);
  const error = useSelector(selectAuthError);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const awaitingOtp = useSelector(selectAwaitingOtp);
  const otpEmail = useSelector(selectOtpEmail);

  const login = useCallback((credentials) => dispatch(loginUser(credentials)), [dispatch]);
  const logout = useCallback(() => dispatch(logoutUser()), [dispatch]);
  const verify = useCallback((payload) => dispatch(verifyOtp(payload)), [dispatch]);
  const goBackToLogin = useCallback(() => dispatch(backToLogin()), [dispatch]);

  return { user, loading, error, isAuthenticated, awaitingOtp, otpEmail, login, logout, verifyOtp: verify, backToLogin: goBackToLogin };
}
